<template>
  <div v-if="!isCompanySpecificRoute" class="bg-[#0F3979] py-2 flex justify-center items-center">
    <div class="text-[#E2EFFF] font-['Poppins'] text-[14px] flex flex-col sm:flex-row items-center gap-2 text-center sm:text-left">
      <span>Tenha seu canal de denúncias no ar em 3 passos</span>
      <router-link to="/planos">
        <button
          class="bg-[#F29221] text-white rounded-md px-4 py-1 font-bold text-[14px] hover:bg-[#E8851F] transition-colors"
          type="button"
        >
          Quero começar!
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComplaintBanner',
  computed: {
    isCompanySpecificRoute() {
      // Check if the current route is /empresas, /planos or like /empresas/{id}
      const path = this.$route.path;
      return path === '/empresas' || path.startsWith('/empresas/') || path === '/planos';
    }
  }
}
</script>
